import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import { Override } from '../../../app-decorators';
import { GaMessageService, IDialog } from '../../../message/ga-message.service';
import { GaEventService, IGAEvent } from '../../../services/ga-event.service';
import { GaDeferredService, IGADeferred } from '../../../services/ga-deferred.service';
import { WebshopCatalogSelectionDialogComponent } from '../../../../main/webshop/catalog-selection/webshop-catalog-selection-dialog.component';
import { ICatalogSelectionRequest } from '../../../../main/webshop/catalog-selection/webshop-catalog-selection-data.service';
import { REPORT_ACTION_CANCELLED } from '../report-actions.helper';
import { EVENT_REPORT_ACTION_DONE } from '../../../app-events';

@Injectable()
export class BpCatalogSelectionHandlerService extends BaseReportActionsHandler {
  private catalogSelectionDialog: IDialog;
  private deferred: IGADeferred<ICatalogSelectionRequest | string | void>;

  constructor(
    private messageService: GaMessageService,
    private eventService: GaEventService,
    private deferredService: GaDeferredService
  ) {
    super();
  }

  @Override(BaseReportActionsHandler)
  public execute(): Promise<ICatalogSelectionRequest | string | void> {
    this.deferred = this.deferredService.defer();

    // register listener
    this.listen();

    this.catalogSelectionDialog = this.messageService.showDialog({
      component: WebshopCatalogSelectionDialogComponent,
      inputs: {
        rowSelection: this.rowSelection
      },
      outputs: {
        onCancel: this.onCancel,
        onSaved: this.onSaved
      },
      wrapperComponent: false
    });

    return this.deferred.promise;
  }

  private listen(): void {
    this.eventHandler = this.eventService.events.subscribe((evt: IGAEvent) => {
      if (evt.name === EVENT_REPORT_ACTION_DONE) {
        this.onClose();
      }
    });
  }

  private onCancel = (): void => {
    this.onClose();
    this.deferred.reject(REPORT_ACTION_CANCELLED);
  };

  private onSaved = (requestData: ICatalogSelectionRequest): void => {
    this.deferred.resolve(requestData);
  };

  private onClose(): void {
    this.catalogSelectionDialog.hide();
    this.eventHandler.unsubscribe();
  }
}